export default {
  1: "Basic",
  2: "Professional",
  3: "Premium",
  4: "Ultimate",
};
